import { resourceSubCategoryEditComponent } from './resource-subcategory-edit.component';

export const resourceSubCategoryEdit = angular
    .module('components.resources.resourceSubCategoryEdit', [])
    .component('resourceSubCategoryEdit', resourceSubCategoryEditComponent)
    .config(($stateProvider) => {

        $stateProvider
            .state('resourceSubCategoryEdit', {
                parent: 'app',
                url: '/home/resources/subcategory/:slug/:id/edit',
                breadcrumbName: 'edit resource',
                parentState: 'resources',
                component: 'resourceSubCategoryEdit',
                resolve: {
                    details($stateParams, resourcesService) {
                        'ngInject';
                        return resourcesService.getResourcesSubCategoryDetailsById($stateParams.id, $stateParams.slug);
                    }

                }

            });
    })
    .name;


// WEBPACK FOOTER //
// ./src/app/components/resources/resource-subcategory-edit/resource-subcategory-edit.module.js